import { equals } from 'ramda';
import { useState } from 'react';
export const useScrollState = () => {
    const [scrollState, setScrollState] = useState({
        scrollLeft: false,
        scrollRight: false,
    });
    const handleScroll = (e) => {
        const { scrollLeft, scrollWidth, offsetWidth } = e.currentTarget;
        const nextScrollState = {
            scrollLeft: scrollLeft > 0,
            scrollRight: scrollLeft + offsetWidth < scrollWidth,
        };
        if (!equals(scrollState, nextScrollState)) {
            setScrollState(nextScrollState);
        }
    };
    return { handleScroll, scrollState };
};
//# sourceMappingURL=useScrollState.js.map